import { FETCH_ALL, FETCH_ALL_FAILURE, FETCH_ALL_SUCCESS } from './constants';
import Api from '../../services/api';

export const fetchAllRequest = () => ({
  type: FETCH_ALL,
});

export const fetchAllRequestFailure = () => ({
  type: FETCH_ALL_FAILURE,
});

export const fetchAllRequestSuccess = (passengers = []) => ({
  type: FETCH_ALL_SUCCESS,
  payload: {
    passengers,
  },
});

export const loadMyFavouritePassengers = () => {
  return async dispatch => {
    dispatch(fetchAllRequest());
    try {
      const response = await Api.myFavouritePassengers();
      dispatch(fetchAllRequestSuccess(response.passengers));
    } catch (e) {
      dispatch(fetchAllRequestFailure());
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/actions.js